import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import router from "./router";
import "./assets/main.scss";

import iconsPlugin from "./plugins/iconsPlugin";
Vue.use(iconsPlugin);


import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import App from "./App.vue";


Vue.use(BootstrapVue);
Vue.use(IconsPlugin);


new Vue({
	router,
	render: h => h(App)
}).$mount("#app");